import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { Paylines } from "../Paylines";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { PortraitLayout } from "../../CustomComponents/PortraitLayout";
import { BaseView } from "../Base/BaseView";
import { WinAnimator2 } from "../../CustomComponents/WinAnimator2";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { TimelineElement } from "../../Components/Elements/Graphics/TimelineElement";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { Symbol } from "../Symbol";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends LayoutContainerElement {
    static TotalWin: TimelineElement;

    private _controller: FreespinsController;
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private _paylines: Paylines;
    private _symbols: Symbols;
    private _machine: Machine;
    private _winAnimator: WinAnimator2;

    private _transformFirstDelay: FrameTimerEventEmitter;
    private _machineStoppedDelay: FrameTimerEventEmitter;

    public static Wilds: Array<Symbol> = [null, null, null, null, null];

    public static WasInit: boolean = false;

    constructor() {
        super();
        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));
        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));
        this._transformFirstDelay = CreateFrameTimer("transformFirstDelay");
        this._transformFirstDelay.on(FrameTimerEvents.Complete, this.spinReceivedDelayed.bind(this));
        this._machineStoppedDelay = CreateFrameTimer("machineStoppedDelay");
        this._machineStoppedDelay.on(FrameTimerEvents.Complete, this.machineStoppedDelay.bind(this));
    }

    public create(node: Element): void {
        super.create(node);
        if (this.childs["Symbols"] != null) {
            this._symbols = this.childs["Symbols"];
            this.removeChild(this._symbols);
        }
        if (this.childs["Paylines"] != null) this._paylines = this.childs["Paylines"];
        if (this.childs["PaylinesTop"] != null) this._paylines.addTopContainer(this.childs["PaylinesTop"]);
        if (this.childs["Machine"] != null) this._machine = this.childs["Machine"];
        if (this.childs["WinAnimator"] != null) this._winAnimator = this.childs["WinAnimator"];
        if (this.childs["Portrait"] != null && this.childs["Portrait"] instanceof PortraitLayout)
            (<PortraitLayout>this.childs["Portrait"]).init(this);
        FreespinsView.TotalWin = this.childs["TotalWin"];
    }

    public initReceived(controller: FreespinsController): void {
        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            this.childs["Teasing"],
                            this.childs["Teasing1"],
                            this.childs["Teasing2"],
                        );
                    }
                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.on(
                            WinAnimator2.FinishQuickWinCalculation,
                            this.finishQuickWinCalculation.bind(this),
                        );
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this.childs["NoWinContainer"],
                            this.childs["WinContainer"],
                        );
                    }
                } else {
                    if (DEBUG) this.log("ERROR no freespin reponse");
                }
            } else {
                if (DEBUG) this.log("ERROR no machine");
            }
        } else {
            if (DEBUG) this.log("ERROR no symbols");
        }
        this.visible = false;
    }

    public startReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.reset(true);
    }

    public spinReceived(): void {
        this.spinReceivedDelayed();
    }

    public spinReceivedDelayed(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    public endReceived(): void {}

    public spin(): void {
        PlayList.loop("SND_FSLoop");
        if (this.childs["Background"] !== null && this.childs["Background"].getCurrentCase() === "WIN")
            this.childs["Background"].goToCase("TO_NORMAL");
        if (this.childs["Retrigger"] !== null && this.childs["Retrigger"].getCurrentCase() === "MESSAGE_START") {
            this.childs["Retrigger"].goToCase("OUTRO");
            PlayList.play("SND_BaseSymElfExpand");
        }

        for (let i: number = 1; i < this._winAnimator.currentSymbols.length - 1; i++) {
            let isFirst: boolean = false;
            for (let j: number = 0; j < this._winAnimator.currentSymbols[i].length; j++) {
                if (!isFirst && this._winAnimator.currentSymbols[i][j].id === 15 && FreespinsView.Wilds[i] !== null) {
                    isFirst = true;
                    let symbol: Symbol = this._winAnimator.currentSymbols[i][j];
                    this._winAnimator.currentSymbols[i][j] = FreespinsView.Wilds[i];
                    FreespinsView.Wilds[i].goToCase("LOOP");
                    this._symbols.returnSymbol(symbol);
                }
            }
        }

        FreespinsView.Wilds[0].goToCase("LOOP");
        this.childs["WildContainers"].addChild(FreespinsView.Wilds[0]);
        FreespinsView.Wilds[4].goToCase("LOOP");
        this.childs["WildContainers"].addChild(FreespinsView.Wilds[4]);

        FreespinsView.Wilds[1] = null;
        FreespinsView.Wilds[2] = null;
        FreespinsView.Wilds[3] = null;
        this._machine.spinStart(this._winAnimator.reset(true, true), true, this._winAnimator.currentSymbols);
    }

    public stop(): void {
        this._machine.spinStop(null, true);
    }

    public initIntro(): void {
        FreespinsView.WasInit = true;
        this.visible = true;
        if (GameManager.freespinsResponse.currentWin > 0 && this.childs["Background"] !== null)
            this.childs["Background"].goToCase("WIN");
        AmbientBackground.changeAmbientBackground("fs", 0);
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);

        let firstPosition: Array<number> = this._winAnimator.expandFirstSymbolPoistion(0);
        let lastPosition: Array<number> = this._winAnimator.expandFirstSymbolPoistion(4);

        let symbol: Symbol = this._symbols.getSymbol(14, "START");
        PlayList.play("SND_BaseSymElfExpand");
        symbol.x = firstPosition[0];
        symbol.y = firstPosition[1];
        this.childs["WildContainers"].addChild(symbol);
        FreespinsView.Wilds[0] = symbol;

        let symbol1: Symbol = this._symbols.getSymbol(14, "START");
        PlayList.play("SND_BaseSymElfExpand");
        symbol1.x = lastPosition[0];
        symbol1.y = lastPosition[1];
        this.childs["WildContainers"].addChild(symbol1);
        FreespinsView.Wilds[4] = symbol1;

        if (GameManager.freespinsResponse.currentWin > 0) {
            this._winAnimator.expandWilds(0);
            this._winAnimator.expandWilds(4);
        }

        for (let i: number = 1; i < 4; i++) {
            let position: Array<number> = this._winAnimator.expandWildsPosition(i);
            let count: number = this._winAnimator.expandWildsCount(i);
            if (count > 1) {
                let symbol: Symbol = this._symbols.getSymbol(10 + count, "START");
                PlayList.play("SND_BaseSymElfExpand");
                symbol.x = position[0];
                symbol.y = position[1];
                this.childs["WildContainers"].addChild(symbol);
                FreespinsView.Wilds[i] = symbol;
                this._winAnimator.expandWilds(i);
            }
        }

        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);
        this.visible = true;
        this.retrigger();
        if (this.isLastFreespin()) {
            this._winAnimator.reset(true);
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSEndWait");
            PlayList.play("SND_FSoutro");

            if (GameManager.freespinsResponse.totalWin > 0) {
                if (FreespinsView.TotalWin != null) {
                    this.childs["TotalWinContainer"].addChild(FreespinsView.TotalWin);
                    FreespinsView.TotalWin.visible = true;
                    FreespinsView.TotalWin.play(GameManager.freespinsResponse.totalWin);
                }
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
    }

    public intro(long: boolean = false): void {
        this.visible = true;
        if (BaseView.Transition != null) {
            this.childs["TotalWinContainer"].addChild(BaseView.Transition);
            BaseView.Transition.goToCase("OUTRO_BASE_END");
        }
        if (this.childs["Background"] !== null) this.childs["Background"].goToCase("NORMAL");

        let firstPosition: Array<number> = this._winAnimator.expandFirstSymbolPoistion(0);
        let lastPosition: Array<number> = this._winAnimator.expandFirstSymbolPoistion(4);

        let symbol: Symbol = this._symbols.getSymbol(14, "START");
        PlayList.play("SND_BaseSymElfExpand");
        symbol.x = firstPosition[0];
        symbol.y = firstPosition[1];
        this.childs["WildContainers"].addChild(symbol);
        FreespinsView.Wilds[0] = symbol;

        let symbol1: Symbol = this._symbols.getSymbol(14, "START");
        PlayList.play("SND_BaseSymElfExpand");
        symbol1.x = lastPosition[0];
        symbol1.y = lastPosition[1];
        this.childs["WildContainers"].addChild(symbol1);
        FreespinsView.Wilds[4] = symbol1;

        this._introDelay.start(60);
    }

    public outro(): void {
        this.visible = true;
        PlayList.stop("SND_FSLoop");
        PlayList.stop("SND_FSEndWait");
        PlayList.play("SND_BaseFSTransform");
        AmbientBackground.changeAmbientBackground("base", 60);
        if (FreespinsView.TotalWin != null) {
            this.childs["TotalWinContainer"].addChild(FreespinsView.TotalWin);
            FreespinsView.TotalWin.goToOutro();
        }

        for (let i: number = 1; i < FreespinsView.Wilds.length; i++) {
            if (FreespinsView.Wilds[i] != null) {
                let symbol = FreespinsView.Wilds[i];
                FreespinsView.Wilds[i] = null;
                this._symbols.returnSymbol(symbol);
            }
        }
        FreespinsView.Wilds = [null, null, null, null, null];

        this.outroFinished();
    }

    public disableLogo(): void {
        if (this.childs["Logo"] != null) this.removeChild(this.childs["Logo"]);
    }

    public enable(): void {
        PlayList.loop("SND_FSMessage");
        if (BaseView.Transition != null) {
            PlayList.play("SND_FSIntro");
            BaseView.Transition.goToCase("MESSAGE_START");
        }
    }

    private onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
        let position: Array<number> = this._winAnimator.expandWildsPosition(this._machine.actualReelStopped);
        let count: number = this._winAnimator.expandWildsCount(this._machine.actualReelStopped);
        if (this._machine.actualReelStopped > 0 && this._machine.actualReelStopped < 4 && count > 1) {
            let symbol: Symbol = this._symbols.getSymbol(10 + count, "START");
            PlayList.play("SND_BaseSymElfExpand");
            symbol.x = position[0];
            symbol.y = position[1];
            FreespinsView.Wilds[this._machine.actualReelStopped] = symbol;
            this.childs["WildContainers"].addChild(symbol);
        }

        if (count > 1) {
            this._winAnimator.expandWilds(this._machine.actualReelStopped);
        }
    }

    private machineStopped(): void {
        this.machineStoppedDelay();
    }

    private machineStoppedDelay(): void {
        this._controller.machineStopped();
        if (GameManager.freespinsResponse.currentWin > 0 && this.childs["Background"] !== null)
            this.childs["Background"].goToCase("WIN");
        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.stop("SND_FSLoop");
        }
        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                this._winAnimator.reset(true);
                PlayList.stop("SND_FSLoop");
                PlayList.loop("SND_FSEndWait");
                PlayList.play("SND_FSoutro");
                if (GameManager.freespinsResponse.totalWin > 0) {
                    if (FreespinsView.TotalWin != null) {
                        this.childs["TotalWinContainer"].addChild(FreespinsView.TotalWin);
                        FreespinsView.TotalWin.visible = true;
                        FreespinsView.TotalWin.play(GameManager.freespinsResponse.totalWin);
                    }
                }
            }
        }
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    private finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    private finishWinAnimator(): void {
        this._controller.allWinsFinished();
        if (this.isLastFreespin()) {
            this._winAnimator.reset(true);
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSEndWait");
            PlayList.play("SND_FSoutro");
            if (GameManager.freespinsResponse.totalWin > 0) {
                if (FreespinsView.TotalWin != null) {
                    this.childs["TotalWinContainer"].addChild(FreespinsView.TotalWin);
                    FreespinsView.TotalWin.visible = true;
                    FreespinsView.TotalWin.play(GameManager.freespinsResponse.totalWin);
                }
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
        this.retrigger();
    }

    private introFinished(): void {
        this.visible = true;
        PlayList.loop("SND_FSLoop");
        this._controller.introFinished();
    }

    private outroFinished(): void {
        if (this.childs["Background"] !== null) this.childs["Background"].goToCase("OUTRO");
        this.visible = false;
        this._winAnimator.resetTimer();
        this._controller.outroFinished();
    }

    private retrigger(): void {
        if (!this.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                        this.childs["Retrigger"].goToCase("MESSAGE_START");
                        FreespinsView.Wilds[0].goToCase("NOWIN_LOOP");
                        FreespinsView.Wilds[4].goToCase("NOWIN_LOOP");
                    }
                }
            }
        }
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }
        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/